module.exports = "/assets/data/15e8f3c2a88b281c794ee924ab2d4cfe-WA3.data.json";